import React from "react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import * as VisuallyHidden from "@radix-ui/react-visually-hidden";
import { RegularButton } from "@/stories/button/button";
import { AlertCircle, CheckCircle } from "lucide-react";

interface ReferStatusModalProps {
    type: "success" | "error";
    message: string;
    isOpen: boolean;
    onClose: (value: boolean) => void;
}

const ReferStatusModal: React.FC<ReferStatusModalProps> = ({ type, message, onClose, isOpen }) => {

    const onClosePopup = () => {
        onClose(false);
    };

    return (
        <Dialog open={isOpen} onOpenChange={onClosePopup}>
            <DialogContent className="w-[90%] rounded-2xl p-9 md:w-[460px]">
                <VisuallyHidden.Root>
                    <DialogTitle>{type === "success" ? "Success" : "Error"} Modal</DialogTitle>
                </VisuallyHidden.Root>
                <div className="w-full text-center">
                    <div className="flex w-full justify-center">
                        {type === "success" ? (
                            <CheckCircle className="h-16 w-16 text-green-500" />
                        ) : (
                            <AlertCircle className="h-16 w-16 text-red-500" />
                        )}
                    </div>
                    <h2 className="mt-4 text-2xl font-semibold">
                        {type === "success" ? "Success" : "Error"}
                    </h2>
                    <p className="mt-2 text-md">{message}</p>
                </div>
                <RegularButton
                    className="h-16 max-w-full text-lg md:mt-8"
                    label="Ok"
                    noIcon
                    showRightIcon={false}
                    onClick={onClosePopup}
                />
            </DialogContent>
        </Dialog>
    );
};

export default ReferStatusModal;
